module.exports = {
      id: "follow-instagram-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "svg-sprite.svg#follow-instagram",
      toString: function () {
        return this.url;
      }
    }